/**
 * Seller-only listing notes stored in listing privateData.
 * Visible to the listing author via ownListings APIs only.
 */

export const SELLER_PRIVATE_NOTE_KEY = 'sellerPrivateNote';
export const SELLER_PRIVATE_NOTE_MAX_LENGTH = 2000;

/**
 * @param {Object|null|undefined} listing - listing or ownListing entity
 * @returns {string|null} trimmed note, or null if empty/absent
 */
export const getSellerPrivateNote = listing => {
  const raw = listing?.attributes?.privateData?.[SELLER_PRIVATE_NOTE_KEY];
  if (typeof raw !== 'string') {
    return null;
  }
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : null;
};

/**
 * @param {Object|null|undefined} listing
 * @returns {boolean}
 */
export const hasSellerPrivateNote = listing => !!getSellerPrivateNote(listing);

/**
 * Normalize form value for Sharetribe privateData merge (null removes the key).
 * @param {string|null|undefined} value
 * @returns {string|null}
 */
export const sellerPrivateNoteForUpdate = value => {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};
